import React, { useState } from "react";
import EventsList from "./EventsList";
import LoadSimple from "../../LoadSimple";
import { capitalizeFirstLetter } from "../../../utils/utils";
import { lang } from "../../generales/traduction";

const TableEvents = ({
  pageActual, startLimit,
  limitList,
  devices,
  dataList,
  cisSelected,
  setCisSelected,
  registerIsValid,
  searchResults,
  setSearchResults,
  onSearch,
  dataUsers,
  setDataUsers,
  searchTerm,
  setSearchTerm,
  server,
  setRegisterIsValid,
  setData,
  setLoading,
  setError,
  handleChangEdit,
  languaje,
  mode,
  setContRowSelected,
  poolRows, setPoolRows,
  poolObjectRows, setPoolObjectRows,
  handleShowPopup,
  buscar_cis,
  loadingList, userPermissions,
  dataAgencies,
  origen,
  setImportModalOpen,
  setSuveryId,
  ubiActual,
}) => {
  const [allSelected, setAllSelected] = useState(false);
  setContRowSelected(poolRows.length)
  const rowSelected = (elemento) => {
    if (allSelected) {
      setAllSelected(false)
    }
    setPoolRows((prevRows) => {
      // Busca si el dispId ya existe en el array
      const exists = prevRows.includes(elemento.eventid);

      // Si existe, filtra para eliminarlo, si no existe, lo agrega
      if (exists) {
        return prevRows.filter(id => id !== elemento.eventid);
      } else {
        return [...prevRows, elemento.eventid];
      }
    });
    setPoolObjectRows((prevRows) => {
      // Busca si el hostid ya existe en el array
      const exists = prevRows.includes(elemento.eventid);

      // Si existe, filtra para eliminarlo, si no existe, lo agrega
      if (exists) {
        return prevRows.filter(eventid => eventid !== elemento.eventid);
      } else {
        return [...prevRows, elemento];

      }
    });
  };
  const handleSelectAll = () => {
    if (allSelected) {
      // Si ya está todo seleccionado, deselecciona todo
      setPoolRows([]);
      setPoolObjectRows([])
    } else {
      setPoolRows(dataList.map(item => item.eventid))
      setPoolObjectRows(dataList)
    }
    setAllSelected(!allSelected); // Alterna el estado de seleccionar todo
  };
  return (
    <div className="mh-alerts-container">
      <div className={"mh-alerts-header head-table-portafolio" + mode} style={{ borderBottom: 'unset', height: '10%' }}>
        <div className="mh-alert-hcell" style={{ width: '3%' }}>
          <div className='cont-checkbox'>
            <input type='checkbox' className='NotifiCheckBox ' checked={allSelected} style={{ height: '15px' }} onClick={() => handleSelectAll()} ></input>
          </div>
        </div>
        <div className="mh-alert-hcell" style={{ width: '4%' }}>ID</div>
        <div className="mh-alert-hcell" style={{ width: '6%' }}>{capitalizeFirstLetter(lang[languaje]['severidad'])}</div>
        <div className="mh-alert-hcell" style={{ width: '20%' }} >{capitalizeFirstLetter(lang[languaje]['Incidencia'])}</div>
        <div className="mh-alert-hcell" style={{ width: '20%' }}>{capitalizeFirstLetter(lang[languaje]['dispositivo'])}</div>
        <div className="mh-alert-hcell" style={{ width: '8%' }}>{capitalizeFirstLetter(lang[languaje]['Estatus'])}</div>
        <div className="mh-alert-hcell" style={{ width: '4%' }}>{'ODD'}</div>
        <div className="mh-alert-hcell" style={{ width: '4%' }}>{'DDT'}</div>
        <div className="mh-alert-hcell" style={{ width: '4%' }}>{'Ack'}</div>
        <div className="mh-alert-hcell" style={{ width: '5%' }}>{'Ticket'}</div>
        <div className="mh-alert-hcell" style={{ width: '4%' }}>{'SLA'}</div>
        <div className="mh-alert-hcell" style={{ width: '7%' }}>{capitalizeFirstLetter(lang[languaje]['tiempoActual'])}</div>
        <div className="mh-alert-hcell" style={{ width: '7%' }}>{capitalizeFirstLetter(lang[languaje]['tiempoUltimaCaida'])}</div>
        <div className="mh-alert-hcell" style={{ width: '10%' }}>{capitalizeFirstLetter(lang[languaje]['fecha'])}</div>
      </div>
      <div className="mh-alerts-body">
        {registerIsValid ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          <EventsList
            pageActual={pageActual}
            limitList={limitList} startLimit={startLimit}
            dataList={dataList}
            devices={devices}
            cisSelected={cisSelected}
            setCisSelected={setCisSelected}
            searchResults={searchResults}
            setSearchResults={setSearchResults}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            dataUsers={dataUsers}
            setDataUsers={setDataUsers}
            server={server}
            setRegisterIsValid={setRegisterIsValid}
            setData={setData}
            setLoading={setLoading}
            setError={setError}
            handleChangEdit={handleChangEdit}
            languaje={languaje}
            mode={mode}
            setContRowSelected={setContRowSelected}
            rowSelected={rowSelected}
            poolRows={poolRows}
            handleShowPopup={handleShowPopup}
            buscar_cis={buscar_cis}
            loadingList={loadingList}
            dataAgencies={dataAgencies}
            origen={origen}
            setImportModalOpen={setImportModalOpen}
            setSuveryId={setSuveryId}
            ubiActual={ubiActual}
            userPermissions={userPermissions}
          //  search_problems={search_problems} 
          ></EventsList>
        )}
      </div>
    </div>
  );
};

export default TableEvents;
